<template>
  <div ref="menuTreeScroll" class="tree-container">
    <div v-if="tooltip.visible" class="tracker-custom-tooltip" :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }">
      {{ tooltip.text }}
    </div>



    <!-- ═══ SEZIONE: Popolari ══════════════════════════════════════════════ -->
    <transition name="fade">
      <div v-if="getFeaturedTournaments.length > 0" class="sidebar-section">
        <div class="sidebar-section__header">
          <span>{{ $t('popularEvents') || 'Popular' }}</span>
        </div>
        <div class="sidebar-section__body">
          <ul class="section-list">
            <li
              v-for="tourn in getFeaturedTournaments"
              :key="'pop-' + tourn.tournamentId"
              class="level-row section-item"
              :class="{ 'is-selected': isFeaturedTournamentActive(tourn.tournamentId) }"
              @click="openFavoriteTournament(tourn)"
            >
              <div class="icon-slot icon-slot--thumb">
                <LogoTournament
                    :tournament-id="tourn.tournamentId || tourn.id"
                    class="thumb-img"
                />
              </div>
              <span class="row-label">{{ tourn.tournamentName }}</span>
              <div class="row-meta">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <!-- ═══ SEZIONE: Alberatura sport ═════════════════════════════════════ -->
    <div class="sidebar-section sidebar-section--tree">
      <div class="sidebar-section__header">
<!--        <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true">-->
<!--          <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/>-->
<!--        </svg>-->
        <span>{{ $t('sports') || 'Sports' }}</span>
      </div>

      <!-- Tree skeleton -->
      <div v-if="loading" class="sidebar-section__body">
        <div v-for="n in 5" :key="'skel-' + n" class="skeleton-row">
          <div class="skel-icon"></div>
          <div class="skel-label"></div>
          <div class="skel-badge"></div>
        </div>
      </div>

      <div v-else>
        <!-- SPORT LEVEL -->
        <ul class="tree-root">
          <li v-for="sport in sportNodes" :key="sport.id" class="sport-item">
            <div
              class="level-row level-sport"
              :class="{ 'is-open': getOpenSportId === (sport.sportId || sport.id) }"
              :title="sport.name"
              @click="onSportClick(sport)"
            >
              <div class="icon-slot icon-slot--sport">
                <img
                  :src="sportIconUrl(sport)"
                  :alt="sport.name"
                  class="sport-img"
                  :class="{ 'img-light': light }"
                  @error="onSportIconError"
                />
              </div>
              <span class="row-label">{{ sport.name }}</span>
              <div class="row-meta">
                <!-- count-badge rimosso dalla UI (sport.count disponibile nel modello) -->
              </div>
            </div>

          </li>
        </ul>

        <!-- ANTEPOST ROOT -->
        <ul class="tree-root antepost-tree">
          <li v-for="sport in antepostNodes" :key="sport.id" class="sport-item">
            <div
              class="level-row level-sport"
              :class="{ 'is-open': isExpanded(sport.id) }"
              :title="sport.name"
              @click="toggleExpand(sport.id, 'antepost_root', sport)"
            >
              <div class="icon-slot icon-slot--sport">
                <img :src="`${sportPath}${iconFolder}/antepost.svg`" alt="Antepost" class="sport-img" @error="onSportIconError" />
              </div>
              <span class="row-label">Antepost</span>
              <div class="row-meta">
                <!-- count-badge rimosso dalla UI (sport.count disponibile nel modello) -->
                <span class="chevron" :class="{ 'chevron--open': isExpanded(sport.id) }"></span>
              </div>
            </div>

            <transition name="expand-fade">
              <div v-if="isExpanded(sport.id)">
                <template v-if="loadingNodes[sport.id]">
                  <div v-for="n in 3" :key="'sk-ar-' + n" class="skeleton-row skeleton-row--l2">
                    <div class="skel-icon"></div>
                    <div class="skel-label"></div>
                    <div class="skel-badge"></div>
                  </div>
                </template>
                <ul v-else class="tree-l2">
                  <li v-for="sportChild in sport.children" :key="sportChild.id + '#antepost'">
                    <div
                      class="level-row level-category"
                      :class="{ 'is-open': isExpanded(sportChild.id) }"
                      @click.stop="toggleExpand(sportChild.id, 'antepost_sport', sportChild)"
                    >
                      <div class="icon-slot icon-slot--category">
                        <img
                          :src="`${sportPath}${iconFolder}/${sportChild.icon_id}.svg`"
                          :alt="sportChild.name"
                          class="sport-img"
                          :class="{ 'img-light': light }"
                          @error="onSportIconError"
                        />
                      </div>
                      <span class="row-label">{{ sportChild.name }}</span>
                      <div class="row-meta">
                        <!-- count-badge rimosso dalla UI (sportChild.count disponibile nel modello) -->
                        <span class="chevron" :class="{ 'chevron--open': isExpanded(sportChild.id) }"></span>
                      </div>
                    </div>

                    <transition name="expand-fade">
                      <div v-if="isExpanded(sportChild.id)">
                        <template v-if="loadingNodes[sportChild.id]">
                          <div v-for="n in 3" :key="'sk-as-' + n" class="skeleton-row skeleton-row--l3">
                            <div class="skel-icon skel-icon--sm"></div>
                            <div class="skel-label"></div>
                            <div class="skel-badge"></div>
                          </div>
                        </template>
                        <ul v-else class="tree-l3">
                          <li v-for="category in sportChild.children" :key="category.id + '#antepost'">
                            <div
                              class="level-row level-category"
                              :class="{ 'is-open': isExpanded(category.id) }"
                              @click.stop="toggleExpand(category.id, 'antepost_category', sportChild, category)"
                            >
                              <div class="icon-slot icon-slot--category">
                                <img
                                  loading="lazy"
                                  :src="`${categoryPath}${category.icon_id}.svg`"
                                  :alt="category.name"
                                  class="category-img"
                                  @error="onImageError"
                                />
                              </div>
                              <span class="row-label">{{ category.name }}</span>
                              <div class="row-meta">
                                <!-- count-badge rimosso dalla UI (category.count disponibile nel modello) -->
                                <span class="chevron" :class="{ 'chevron--open': isExpanded(category.id) }"></span>
                              </div>
                            </div>

                            <transition name="expand-fade">
                              <div v-if="isExpanded(category.id)">
                                <template v-if="loadingNodes[category.id]">
                                  <div v-for="n in 3" :key="'sk-ac-' + n" class="skeleton-row skeleton-row--l4">
                                    <div class="skel-icon skel-icon--sm"></div>
                                    <div class="skel-label"></div>
                                  </div>
                                </template>
                                <ul v-else class="tree-l4">
                                  <template v-for="tournament in category.children">
                                    <li
                                      v-if="tournament.events && tournament.events.length > 0"
                                      :key="'th-' + tournament.id"
                                      class="antepost-group-label"
                                    >
                                      {{ tournament.name }}
                                    </li>
                                    <li
                                      v-for="event in tournament.events"
                                      :key="event.eventId"
                                      class="level-row level-tournament"
                                      :class="{ 'is-selected': isTournamentActive(event.eventId) }"
                                      @click.stop="getDetailAntepost(event, tournament, sportChild)"
                                    >
                                      <span class="row-label">{{ event.eventName }}</span>
                                      <span class="chevron chevron--right"></span>
                                    </li>
                                  </template>
                                </ul>
                              </div>
                            </transition>
                          </li>
                        </ul>
                      </div>
                    </transition>
                  </li>
                </ul>
              </div>
            </transition>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isMobileOnly, isTablet } from 'mobile-device-detect';
import LogoTournament from "@/components/center_widgets/LogoTournament.vue";


export default {
  name: 'TreeAmerican',
  components: { LogoTournament },

  data: () => ({
    loading: false,
    expanded: {},
    loadingNodes: {},
    // getFeaturedTournaments moved to featuredEvents store
    foundFavourites: [],      // user-starred tournaments (session)
    isMobileOnly,
    isTablet,
    light: false,
    categoryPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/categories/round_flags/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/',
    timeFilters: [0, 3, 6, 12, 24],
    tooltip: { visible: false, text: '', x: 0, y: 0 }
  }),

  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getTreeV2: 'treeV2/getTree',
      getFilter: 'treeV2/getFilter',
      getTournamentsActive: 'previewPrematch/getTournamentsActive',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getSettings: 'cart/getSettings',
      getFirstLoading: 'odds/getFirstLoading',
      getIcon: 'settings/getIcon',
      getGameConsole: 'settings/getGameConsole',
      apiUrl: 'settings/getUrlApi',
      token: 'settings/getToken',
      getEventsDetailActive: 'detailPrematch/getEventsDetailActive',
      getMixedPreview: 'topsports/getMixedPreview',
      getOpenSportId: 'topsports/getOpenSportId',
      getFeaturedTournaments: 'featuredEvents/getFeaturedTournaments',
      getPreview: 'previewPrematch/getPreview',
    }),

    iconFolder() {
      if (this.getIcon === 'Color') {
        this.light = false;
        return 'icons-color';
      }
      return 'icons-color';
    },

    isMobile() {
      return this.isMobileOnly || this.isTablet;
    },

    favouritesSet() {
      const set = new Set();
      this.foundFavourites.forEach(fav => set.add(fav.id));
      return set;
    },

    sportNodes() {
      return (this.getTreeV2 || []).filter(n => n.type === 'sport');
    },

    antepostNodes() {
      return (this.getTreeV2 || []).filter(n => n.type === 'antepost_root');
    },
  },

  methods: {
    ...mapActions({
      fetchTreeV2Complete: 'treeV2/fetchTreeV2Complete',
      setFilter: 'treeV2/setFilter',
      fetchPreview: 'previewPrematch/fetchPreview',
      fetchPreviewV3: 'previewPrematch/fetchPreviewV3',
      fetchAntepost: 'detailPrematch/fetchAntepost',
      setLoadingPreview: 'odds/setLoadingPreview',
      setStatusQbet: 'tree/setStatusQbet',
      setViewMode: 'ui/setViewMode',
      setSubaction: 'ui/setSubaction',
      closeTopsportsPanel: 'topsports/closePanel',
      toggleSport: 'topsports/toggleSport',
      fetchCategoryTreeForSport: 'treeV2/fetchCategoryTreeForSport',
      fetchTournamentsTreeForCategory: 'treeV2/fetchTournamentsTreeForCategoryV3',
      fetchAntepostCategoryTreeForSport: 'treeV2/fetchAntepostCategoryTreeForSportV3',
      fetchAntepostTournamentsTreeForSport: 'treeV2/fetchAntepostTournamentsTreeForSportV3',
      clearAllDetail: 'detailPrematch/clearAllDetail',
      loadFeaturedTournamentsStore: 'featuredEvents/loadFeaturedTournaments',
      closeTournament: 'sportNavigation/closeTournament',
    }),

    showTooltip(e, text) {
      this.tooltip.text = text;
      this.tooltip.visible = true;
      this.tooltip.x = e.clientX + 15;
      this.tooltip.y = e.clientY + 15;
    },
    updateTooltipPos(e) {
      if (this.tooltip.visible) {
        this.tooltip.x = e.clientX + 15;
        this.tooltip.y = e.clientY + 15;
      }
    },
    hideTooltip() {
      this.tooltip.visible = false;
    },

    sportIconUrl(sport) {
      return sport.name.includes('Antepost')
        ? `${this.sportPath}antepost.svg`
        : `${this.sportPath}${this.iconFolder}/${sport.icon_id}.svg`;
    },

    setNodeLoading(id, val = true) {
      this.$set(this.loadingNodes, id, val);
    },

    onImageError(e) {
      e.target.src = `${this.categoryPath}1.svg`;
    },

    onSportIconError(e) {
      e.target.style.visibility = 'hidden';
    },

    onFavImageError(e) {
      e.target.style.visibility = 'hidden';
    },

    isExpanded(id) {
      return !!this.expanded[id];
    },
    async openFavoriteTournament(tournament) {
      if (this.isFeaturedTournamentActive(tournament.tournamentId)) {
        await this.closeTournament({ tournamentId: tournament.tournamentId });
        return;
      }
      const wasInEventDetail = (this.getEventsDetailActive || []).length > 0;
      this.closeTopsportsPanel();
      this.clearAllDetail();
      this.setStatusQbet(false);
      await this.setLoadingPreview({ status: true });
      this.$store.commit("previewPrematch/SET_PREVIEW", []);
      if (this.isMobile) {
        this.$root.$emit('close_sidebar_left', true);
      }

      await this.fetchPreviewV3({
        source: tournament.tournamentId + '#prematch',
        tournament: tournament.tournamentId,
        sportId: tournament.sportId,
        categoryId: tournament.categoryId,
        type: 'previewOdds',
        mobilePlatform: wasInEventDetail ? false : this.isMobile,
        groupOddsWithSpreads: true,
        forceDefaultGameConsole: false,
        forceCallApi: true,
      });
      if (this.isMobile) {
        this.setViewMode({ mode: 'preview' });
      }
      await this.setLoadingPreview({ status: false });
      this.$nextTick(() => window.scrollTo({ top: 0 }));
    },


    onSportClick(sport) {
      const sportId = sport.sportId || sport.id;
      const isClosing = this.getOpenSportId === sportId;
      this.clearAllDetail();

      this.toggleSport(sportId);
      this.setSubaction(isClosing ? 'home' : 'prelive');
    },

    async toggleExpand(id, type, sport, category) {
      const wasExpanded = !!this.expanded[id];
      this.$set(this.expanded, id, !wasExpanded);

      if (!this.expanded[id]) return;

      this.setNodeLoading(id, true);
      try {
        if (type === 'category') {
          await this.fetchTournamentsTreeForCategory({ sportId: sport.sportId, categoryId: category.categoryId });
        } else if (type === 'antepost_root' || type === 'antepost_sport') {
          await this.fetchAntepostCategoryTreeForSport({ sportId: sport.sportId });
        } else if (type === 'antepost_category') {
          const sportId = sport.icon_id || sport.sportId;
          const categoryId = category.icon_id || category.categoryId;
          await this.fetchAntepostTournamentsTreeForSport({ sportId, categoryId });
        }
      } finally {
        this.setNodeLoading(id, false);
      }
    },

    isTournamentActive(id) {
      return (this.getTournamentsActive || []).some(activeId => activeId == id || activeId == id + '#antepost');
    },

    isFeaturedTournamentActive(tournamentId) {
      const source = tournamentId + '#prematch';
      return (this.getPreview || []).some(p => p.source === source)
        || (this.getMixedPreview && this.getMixedPreview.tournament && this.getMixedPreview.tournament.id == tournamentId);
    },

    isFavourite(id) {
      return this.favouritesSet.has(id);
    },

    async changeStatusFavourite(item, sport, category) {
      let savedFavourites = JSON.parse(localStorage.getItem('favourites')) || [];
      let removedFavourites = JSON.parse(localStorage.getItem('removed_favourites')) || [];

      if (this.isFavourite(item.id)) {
        this.foundFavourites = this.foundFavourites.filter(f => f.id !== item.id);
        savedFavourites = savedFavourites.filter(id => id !== item.id);
        if (!removedFavourites.includes(item.id)) removedFavourites.push(item.id);
      } else {
        // Store only the fields needed for display and reopening — keeps cookie size minimal
        this.foundFavourites.push({
          id: item.id,
          tournamentId: item.tournamentId,
          name: item.name,
          sportId: sport.sportId,
          sportName: sport.name,
          categoryId: category.categoryId,
          categoryName: category.name,
        });
        if (!savedFavourites.includes(item.id)) savedFavourites.push(item.id);
        removedFavourites = removedFavourites.filter(id => id !== item.id);
      }

      localStorage.setItem('favourites', JSON.stringify(savedFavourites));
      localStorage.setItem('removed_favourites', JSON.stringify(removedFavourites));
      this.saveFavouritesToCookie();
    },

    async reloadFilter(hour) {
      if (hour === this.getFilter) return;
      this.loading = true;
      await this.setFilter(hour);
      await this.fetchTreeV2Complete({ hour });
      this.loading = false;
    },

    async getDetail(sport, element, mode = null, category = null) {
      if (element && this.isFeaturedTournamentActive(element.tournamentId)) {
        return;
      }
      if (mode !== null || !element) return;

      const wasInEventDetail = (this.getEventsDetailActive || []).length > 0;
      this.closeTopsportsPanel();
      this.clearAllDetail();
      this.setStatusQbet(false);
      await this.setLoadingPreview({ status: true });

      if (this.isMobile) {
        this.$root.$emit('close_sidebar_left', true);
      }

      await this.fetchPreview({
        tournament: element.tournamentId,
        tournamentName: element.name,
        type: 'previewOdds',
        source: element.tournamentId + '#prematch',
        sportId: sport ? sport.sportId : null,
        sportName: sport ? sport.name : null,
        categoryId: category ? category.categoryId : null,
        categoryName: category ? category.name : null,
        forceDefaultGameConsole: false,
        mobilePlatform: wasInEventDetail ? false : this.isMobile,
        groupOddsWithSpreads: true,
      });

      if (this.isMobile) {
        this.setViewMode({ mode: 'preview' });
      }

      await this.setLoadingPreview({ status: false });
      this.$nextTick(() => window.scrollTo({ top: 0 }));
    },
    async getDetailAntepost(event, tournament, sport) {
      if (!event || !event.eventId) return;
      this.closeTopsportsPanel();
      this.clearAllDetail();
      this.setStatusQbet(false);
      await this.setLoadingPreview({ status: true });
      if (this.isMobile) {
        this.$root.$emit('close_sidebar_left', true);
      }
      await this.fetchAntepost({
        idEvent: event.eventId,
        type: 'antepost',
        source: event.eventId,
        sportId: tournament ? tournament.sportId : null,
        tournamentId: tournament ? tournament.tournamentId : null,
        categoryId: tournament ? tournament.categoryId : null,
      });
      if (this.isMobile) {
        this.setViewMode({ mode: 'preview' });
      }
      await this.setLoadingPreview({ status: false });
    },

    // Opens a user-starred tournament (data comes from foundFavourites).
    // Uses fetchPreviewV3 (same as popular events) to ensure the correct tournament
    // is opened by tournamentId, not by sport. Falls back to fav.id for legacy items
    // stored before tournamentId was persisted.
    async openUserFavourite(fav) {
      const favSource = (fav.tournamentId || fav.id) + '#prematch';
      if ((this.getPreview || []).some(p => p.source === favSource)) return

      const tournamentId = fav.tournamentId || fav.id;
      const wasInEventDetail = (this.getEventsDetailActive || []).length > 0;
      this.closeTopsportsPanel();
      this.clearAllDetail();
      this.setStatusQbet(false);
      await this.setLoadingPreview({ status: true });
      if (this.isMobile) {
        this.$root.$emit('close_sidebar_left', true);
      }

      await this.fetchPreviewV3({
        source: tournamentId + '#prematch',
        tournament: tournamentId,
        sportId: fav.sportId || null,
        categoryId: fav.categoryId || null,
        type: 'previewOdds',
        mobilePlatform: wasInEventDetail ? false : this.isMobile,
        groupOddsWithSpreads: true,
        forceDefaultGameConsole: false,
      });
      if (this.isMobile) {
        this.setViewMode({ mode: 'preview' });
      }
      await this.setLoadingPreview({ status: false });
      this.$nextTick(() => window.scrollTo({ top: 0 }));
    },

    // Removes a tournament from user favourites directly from the Preferiti box.
    // Reconstructs the minimal objects expected by changeStatusFavourite so the
    // remove branch fires (isFavourite will return true) and the cookie is updated.
    removeFavourite(fav) {
      this.changeStatusFavourite(
        { id: fav.id, tournamentId: fav.tournamentId, name: fav.name },
        { sportId: fav.sportId, name: fav.sportName, icon_id: null },
        { categoryId: fav.categoryId, name: fav.categoryName, icon_id: null },
      );
    },

    // ── Cookie helpers ──────────────────────────────────────────────────────

    // Persists foundFavourites to a 1-year cookie.
    // Only minimal fields are serialised to stay well within the 4KB cookie limit.
    saveFavouritesToCookie() {
      const data = this.foundFavourites.map(({ id, tournamentId, name, sportId, sportName, categoryId, categoryName }) => ({
        id, tournamentId, name, sportId, sportName, categoryId, categoryName,
      }));
      const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
      try {
        document.cookie = `fav_tournaments=${encodeURIComponent(JSON.stringify(data))}; expires=${expires}; path=/; SameSite=Lax`;
        this.$root.$emit('favourites-updated');
      } catch {
        // Serialisation error or cookie blocked — fail silently
      }
    },

    // Restores favourites from cookie after the tree has loaded.
    // Validates each entry against the available sport nodes (O(1) Set lookup)
    // so stale favourites for removed sports are discarded without extra API calls.
    // Tournament-level existence cannot be verified without lazy-loading the full
    // tree; sport-level validation catches the most common stale-data cases.
    restoreFavouritesFromCookie() {
      const match = document.cookie.match(/(?:^|; )fav_tournaments=([^;]*)/);
      if (!match) return;
      try {
        const restored = JSON.parse(decodeURIComponent(match[1]));
        if (!Array.isArray(restored) || restored.length === 0) return;

        // Build a Set of valid sportIds for O(1) lookup — avoids scanning sportNodes
        // repeatedly for each favourite.
        const validSportIds = new Set(this.sportNodes.map(s => String(s.sportId)));

        this.foundFavourites = restored.filter(fav =>
          // Pass through items that have no sportId (legacy) or whose sport still exists
          !fav.sportId || validSportIds.has(String(fav.sportId))
        );
      } catch {
        // Corrupt or oversized cookie — ignore and start with an empty list
      }
    },

    // Opens a featured/popular tournament

  },

  async created() {
    this.loading = true;
    await Promise.all([
      this.fetchTreeV2Complete({}),
      this.loadFeaturedTournamentsStore({ isMobile: this.isMobile }),
    ]);
    this.loading = false;
    // Restore after tree load so sportNodes is populated for validation
    this.restoreFavouritesFromCookie();
  },

  mounted() {
    this.$root.$on('favourites-updated', this.restoreFavouritesFromCookie);
  },

  beforeDestroy() {
    this.$root.$off('favourites-updated', this.restoreFavouritesFromCookie);
  },
};
</script>

<style scoped>

/* ─── Reset ───────────────────────────────────────────────────────────────── */

.tree-container    { display: flex; flex-direction: column; gap: 0; padding: 0.25rem }
.tree-root, .tree-l2, .tree-l3, .tree-l4, .section-list { list-style: none; margin: 0; padding: 0; }

/* ─── Time filter ─────────────────────────────────────────────────────────── */

.time-filter {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 10px 8px;
}

.btn-time {
  flex: 1;
  padding: 5px 2px;
  font-size: var(--font-size-xl);
  font-weight: 500;
  border-radius: 6px!important;
  background: transparent;
  color: var(--text-op-50-platform)!important;
  cursor: pointer;
  transition: background 0.13s, color 0.13s, border-color 0.13s;
  white-space: nowrap;
}

.btn-time:hover {
}

.btn-time.btn-time--active {
  background: var(--btn-background) !important;
  color: var(--btn-text)!important;
  font-weight: 600;
}

/* ─── Sidebar section (card) ──────────────────────────────────────────────── */

/*
  Each macro-block (Preferiti, Popolari, Sport) lives inside a .sidebar-section.
  The card treatment (border + subtle bg) is applied to the first two;
  the sport tree gets a frameless variant via the --tree modifier.
*/

.sidebar-section {
  margin: 0 8px 10px;
  border-radius: 8px;
  overflow: hidden;
  background: var(--sidebar);
}

.sidebar-section--tree {
  margin: 0 8px 10px;
  border-radius: 8px;
}

.sidebar-section__header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px 8px 0;
  font-size: var(--font-size-4xl);
  font-weight: 700;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.38); /* icona SVG */
}

/* Solo il testo del titolo usa il colore brand */
.sidebar-section__header span {
  color: var(--color-accent);
}

.sidebar-section__body {
  padding: 4px 0;
}

/* ─── Section list items (Preferiti + Popolari) ───────────────────────────── */

.section-item {
  padding: 0!important;
  min-height: 35px;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--text-platform);
  border-radius: 0;
}



/* ─── Empty state ─────────────────────────────────────────────────────────── */

.empty-state {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px 11px;
  color: var(--text-op-50-platform);
  font-size: var(--font-size-2xl);
  font-style: italic;
  line-height: 1.4;
}

/* ─── Row base ────────────────────────────────────────────────────────────── */

/*
  Shared base for every interactive row.
  Column structure: [icon-slot fixed] [label flex] [meta fixed]
  Icon slot always occupies its reserved width regardless of image state.
*/

.level-row {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: background 0.12s, color 0.12s;
  padding-right: 10px;
  border-left: 3px solid transparent;
  margin-bottom: 6px;
}

/* ─── Icon slots — fixed-width reserves ───────────────────────────────────── */

.icon-slot {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-slot--sport    { width: 16px; height: 16px; margin-right: 6px; }
.icon-slot--category { width: 24px; height: 24px; margin-right: 6px; }
.icon-slot--fav-btn  { width: 20px; height: 20px; margin-right: 6px; }
.icon-slot--thumb    { width: 22px; height: 22px; margin-right: 4px; border-radius: 4px; overflow: hidden; flex-shrink: 0; }

/* ─── Images ──────────────────────────────────────────────────────────────── */

.sport-img    { width: 16px; height: 16px; object-fit: contain; flex-shrink: 0; }
.category-img { width: 20px; height: 20px; object-fit: contain; flex-shrink: 0; border-radius: 2px; }
.thumb-img    { width: 20px; height: 20px; object-fit: cover; display: block; }
.img-light    { filter: invert(1); }

/* ─── Row label ───────────────────────────────────────────────────────────── */

.row-label {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ─── Row meta (badge + chevron) ──────────────────────────────────────────── */

.row-meta {
  display: flex;
  align-items: center;
}

/* ─── Count badge — UI DISABILITATA ──────────────────────────────────────── */
/*
  I badge con il conteggio eventi sono stati rimossi dal template su richiesta.
  Il CSS è commentato per mantenere la logica documentata e ripristinabile.

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 17px;
  padding: 0 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.48);
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  flex-shrink: 0;
}

.count-badge--sport {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.65);
}
*/

/* ─── Chevron ─────────────────────────────────────────────────────────────── */

.chevron {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: 1.5px solid var(--text-op-50-platform);
  border-bottom: 1.5px solid var(--text-op-50-platform);
  transform: rotate(45deg);
  transition: transform 0.2s cubic-bezier(0.4, 1.5, 0.6, 1);
  flex-shrink: 0;
}

.chevron--open  { transform: rotate(225deg); }
.chevron--right { transform: rotate(-45deg); }

/* ─── LEVEL 1 — Sport ─────────────────────────────────────────────────────── */

.sport-item {
}

.sport-item:last-child {
  border-bottom: none;
}

.level-sport {
  min-height: 35px;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--text-platform);
  border-radius: 0;
  border-left: 3px solid transparent; /* reserved — prevents shift on open */
}

.level-sport.is-open {
}

/* ─── LEVEL 2 — Category ──────────────────────────────────────────────────── */

.tree-l2 {
  padding: 3px 0 5px;
  background: rgba(0, 0, 0, 0.1);
}

.level-category {
  padding: 7px 16px 7px 40px;
  font-size: var(--font-size-3xl);
  font-weight: 500;
  color: var(--text-op-50-platform);
  border-left: 3px solid transparent;
}

.level-category:hover {
  background: var(--bg-card);
  color: rgba(255, 255, 255, 0.88);
}

.level-category.is-open {
  color: var(--text-platform);
  border-left-color: var(--btn-background-second);
}

/* ─── LEVEL 3 — Tournament ────────────────────────────────────────────────── */

.tree-l3 { padding: 2px 0 4px; }

.level-tournament {
  padding: 6px 4px 6px 50px;
  font-size: var(--font-size-2xl);
  font-weight: 400;
  color: var(--text-platform);
  border-radius: 4px;
}

.level-tournament:hover {
  background: var(--bg-card);
  color: rgba(255, 255, 255, 0.82);
}

.level-tournament.is-selected {
  color: var(--color-primary-light);
  font-weight: 600;
  background: var(--bg-cell-hover);
}

/* ─── LEVEL 4 — Antepost events ───────────────────────────────────────────── */

.tree-l4 { padding: 2px 0 4px; list-style: none; }

.tree-l4 .level-tournament {
  padding-left: 22px;
}

.antepost-group-label {
  font-size: var(--font-size-md);
  font-weight: 700;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.26);
  padding: 8px 10px 3px 22px;
  list-style: none;
}

/* ─── Fav star button ─────────────────────────────────────────────────────── */

.fav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  transition: background 0.12s;
}

.fav-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.star-icon {
  fill: rgba(255, 255, 255, 0.16);
  transition: fill 0.14s;
  flex-shrink: 0;
}

.star-icon--active {
  fill: #fed430;
  filter: drop-shadow(0 0 3px rgba(254, 212, 48, 0.45));
}

/* ─── Skeleton ────────────────────────────────────────────────────────────── */

.skeleton-row {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
}

.skeleton-row--l2 { padding-left: 22px; }
.skeleton-row--l3 { padding-left: 34px; }
.skeleton-row--l4 { padding-left: 44px; }

.skel-icon {
  width: 20px; height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
  background: linear-gradient(90deg, #252b34 30%, #374256 50%, #252b34 70%);
  background-size: 200% 100%;
  animation: shimmer 1.6s infinite linear;
}

.skel-icon--sm { width: 16px; height: 16px; }

.skel-label {
  flex: 1 1 0;
  height: 12px;
  border-radius: 3px;
  background: linear-gradient(90deg, #252b34 30%, #374256 50%, #252b34 70%);
  background-size: 200% 100%;
  animation: shimmer 1.6s infinite linear;
}

.skel-badge {
  width: 24px; height: 14px;
  border-radius: 4px;
  flex-shrink: 0;
  background: linear-gradient(90deg, #252b34 30%, #374256 50%, #252b34 70%);
  background-size: 200% 100%;
  animation: shimmer 1.6s infinite linear;
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ─── Transitions ─────────────────────────────────────────────────────────── */

.expand-fade-enter-active,
.expand-fade-leave-active {
  overflow: hidden;
  transition: max-height 0.22s ease, opacity 0.16s ease;
}

.expand-fade-enter,
.expand-fade-leave-to {
  max-height: 0 !important;
  opacity: 0;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ─── Antepost tree spacing ───────────────────────────────────────────────── */

.antepost-tree { margin-top: 4px; }
.antepost-tree .row-label{
  font-weight: bolder;
}
.antepost-tree .tree-l2 .level-category{
    padding: 10px 10px 10px 10px;
    font-size: var(--font-size-3xl);
    font-weight: 700;
    color: rgba(255, 255, 255, 0.88);
    border-radius: 0;
    border-left: 3px solid transparent; /* reserved — prevents shift on open */
}

.tracker-custom-tooltip {
  position: fixed; background: var(--bg-card); color: #fff;
  padding: 8px 14px; border-radius: 8px; font-size: var(--font-size-2xl); font-weight: 900;
  z-index: 999999; pointer-events: none; box-shadow: 0 4px 15px rgba(0,0,0,0.8);
  white-space: nowrap; transform: translate(0, 0);
}

</style>
